import './global-styles/global.less';
import Main from "./pages/Main/Main";
import { ConfigProvider } from 'antd';
import esEs from 'antd/es/locale/es_ES';

function App() {
  return (
    //Se traduce el app a español
    <ConfigProvider locale={esEs}>
      <Main></Main>
    </ConfigProvider> 
  );
}

export default App;
